import { isSignedUpForAnyItem } from "Signups/SignupsPublicPage/SignupItem/utils/useIsSignedUpForAnyItem.js";

export function checkHouseholdForCurrentSignups({
  household,
  userSignupItems,
  signupItemID,
  allowMultipleItemSignups,
}) {
  const isSignedUp = isSignedUpForAnyItem(userSignupItems);
  if (!isSignedUp) return household;

  const currentItemUserIDs = getCurrentItemUserIDs(
    userSignupItems,
    signupItemID
  );
  const otherItemUserIDs = getOtherItemUserIDs(userSignupItems, signupItemID);

  return household.map((m) => {
    const isSignedUpForCurrentItem = currentItemUserIDs.includes(m.userID);
    const isSignedUpForOtherItem = allowMultipleItemSignups
      ? false
      : otherItemUserIDs.includes(m.userID);

    return {
      ...m,
      isSignedUpForCurrentItem,
      isSignedUpForOtherItem,
    };
  });
}

function getCurrentItemUserIDs(userSignupItems, signupItemID) {
  try {
    return userSignupItems[signupItemID].respondents.map((r) => r.userID);
  } catch (e) {
    return [];
  }
}

function getOtherItemUserIDs(userSignupItems, signupItemID) {
  try {
    const otherItemUserIDs = [];

    Object.keys(userSignupItems).forEach((itemID) => {
      const isCurrentSignupItem = String(itemID) === String(signupItemID);
      if (!isCurrentSignupItem) {
        // push each respondent into `allOtherItemSignups`
        userSignupItems[itemID].respondents?.forEach((r) => {
          otherItemUserIDs.push(r.userID);
        });
      }
    });

    return otherItemUserIDs;
  } catch (e) {
    return [];
  }
}
